import React, { useMemo } from 'react'
import Tab, { TabItem } from '@/components/tab/tab'
import { MainHeader, Column, Expaned } from '@/components/layout/layout'
import { RouteComponentProps } from 'react-router'
import { observer } from 'mobx-react'
import MaterialContent, { INTERNAL_PICTURE_MATERIAL_PATH, PICTURE_MATERIAL_PATH, VIDEO_MATERIAL_PATH } from './router'
import './material.scss'
import useBemClass from '@/utils/hooks/useBEMClass'
import SearchInput from '@/components/search-input/search-input'
import Button from '@/components/button/button'
import { showLayer } from '@/utils/layer'
import UploadMaterial from '../goods-manage/components/upload-material/upload-material'
import { materialStore } from './store'
import SearchTipBox from '../mall-manage/component/search-box/search-box'

const Material = observer((props: RouteComponentProps) => {
    const tabList: TabItem[] = useMemo(
        () => [
            {
                id: 0,
                name: '图片',
                route: PICTURE_MATERIAL_PATH,
            },
            {
                id: 1,
                name: '视频',
                route: VIDEO_MATERIAL_PATH,
            },
            {
                id: 2,
                name: '内置素材',
                route: INTERNAL_PICTURE_MATERIAL_PATH,
            },
        ],
        [],
    )

    const getCls = useBemClass('material-manage')

    return (
        <Column className={getCls()}>
            <MainHeader>
                <Tab tabList={tabList} />
            </MainHeader>
            <div className={getCls('header')}>
                <Button
                    style={{
                        marginRight: '16px',
                    }}
                    types="default"
                    onClick={() => {
                        showLayer(
                            <UploadMaterial
                                onUpload={() => {
                                    materialStore.setMaterialStatus()
                                }}
                            />,
                        )
                    }}
                >
                    添加素材
                </Button>
                <SearchInput
                    isExpaned={false}
                    placeholder="请输入素材名称搜索"
                    onDelete={() => {
                        materialStore.setKeyWord('')
                    }}
                    onSearch={val => {
                        materialStore.setKeyWord(val)
                    }}
                />
            </div>

            {materialStore.keyWord && (
                <SearchTipBox
                    keyWord={materialStore.keyWord}
                    onClose={() => {
                        materialStore.setKeyWord('')
                    }}
                />
            )}

            <Expaned className={getCls('content')}>
                <MaterialContent {...props} />
            </Expaned>
        </Column>
    )
})

export default Material
